import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81bf351e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Upload: require('/app/components/upload.vue').default,Files: require('/app/components/files.vue').default,Signin: require('/app/components/signin.vue').default})
